import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-bookmark-video-card',
  templateUrl: './bookmark-video-card.component.html',
  styleUrls: ['./bookmark-video-card.component.css']
})
export class BookmarkVideoCardComponent implements OnInit {

  @Input() cardID: number;
  @Input() cardTitle: any;
  @Input() videoData:any = [];
  @Input() isFromMyLibrary:any;
  @Input() isFromMyHistory:any;
  noOfViews:any;
  constructor(public selfLearnService: SelfLearnService, public router:Router) { }

  ngOnInit(): void {
    this.noOfViews = this.getNoOfViews();
  }

  displayTime(duration:any){
    return this.selfLearnService.secondsToTime(duration);
  }

  getNoOfViews(){
    return this.selfLearnService.generateRandomNumber();
  }

  displayImage(url:any){
    return url?.replaceAll('https', 'http');
  }
  setLocalStorageForPlaybackScreen(){
    localStorage.setItem("selfLearnPreviousPage", 'chapter');
    localStorage.setItem('selfLearnSelectedSubjectName',this.videoData.nodeName);
    localStorage.setItem("selfLearnSelectedSubject",this.videoData.subjectId);
    localStorage.setItem("chapterId",this.videoData.chapterId);
    localStorage.setItem("chapterName",this.videoData.chapterName);
    if(this.videoData.topicId && this.videoData.topicName){
      localStorage.setItem("selfLearnSelectedTopicId", this.videoData.topicId)
      localStorage.setItem("selfLearnSelectedTopicName",this.videoData.topicName)
      localStorage.removeItem("selfLearnSelectedPlayName");
      localStorage.removeItem("selfLearnSelectedPlayList");
    }else{
      localStorage.removeItem("selfLearnPreviousPage");
      if(this.videoData.chapterId && this.videoData.chapterName){
        localStorage.setItem("selfLearnSelectedVideoType",'reviseVideos');
        localStorage.removeItem('reviseVideosPlayList')
       // localStorage.setItem('reviseVideosPlayList',JSON.stringify(this.reviseVideos));
        localStorage.setItem('selfLearnSelectedPlayList','666');
      }else{
        localStorage.removeItem("selfLearnSelectedVideoType");
        localStorage.setItem("selfLearnSelectedPlayName", "Recommended");
        localStorage.setItem("selfLearnSelectedPlayList", '6');
      }

    }

    localStorage.setItem('selfLearnSelectedVideoId', this.videoData.id ? this.videoData.id : this.videoData.videoId )
    localStorage.setItem('selectedTopicName',this.videoData.name);
    localStorage.setItem('isFromHomeScreen','true');
    localStorage.setItem('previousScreen', !this.isFromMyLibrary ? this.isFromMyHistory ? 'selfLearn-V2/my-history' :'selfLearn-V2/bookmarks' : 'selfLearn-V2/my-library')
    this.router.navigateByUrl("selfLearn-V2/videoplayback");
  }

}
